import PropTypes from "prop-types";

export const GeneGTExType = PropTypes.shape({
  version: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      exons: PropTypes.arrayOf(PropTypes.shape({})),
      gencode_id: PropTypes.string,
      gene: PropTypes.string,
      gene_expressions: PropTypes.shape({}),
      gene_model_positions: PropTypes.shape({
        strand: PropTypes.string,
        start: PropTypes.number,
        chromosome: PropTypes.string,
        end: PropTypes.number,
      }),
      gene_positions: PropTypes.shape({
        strand: PropTypes.string,
        start: PropTypes.number,
        chromosome: PropTypes.string,
        end: PropTypes.number,
      }),
    })
  ),
});
